const CORES_WITH_VISIT_HISTORY = ['nuc ribeirao preto dom'];

export const isAuthorizedCore = core => {
  return CORES_WITH_VISIT_HISTORY.includes(core);
};
